import React, { useState } from "react";

import { styled } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";

import {
  EmergencyContactById,
} from "../../../Api/Services/EmergencyServices";
import { getPetByID } from "../../../Api/Services/PetServices";
import { formatPhoneNumber } from "../../../Utils";
import ParDataView from "../../Common/PawDataView";

export default function ArchiveEmergencyInfo() {
  const { id } = useParams();
  const [petId, setPetId] = useState("");
  const navigate = useNavigate();

  const { data, isLoading: isEmergencyContactLoading } = useSWR(
    id ? `data${id}` : null,
    async () => {
      const { data } = await EmergencyContactById(id);
      setPetId(data?.data?.[0]?.pet_id);
      return data?.data?.[0] || [];
    },
    {
      revalidateOnFocus: false,
    }
  );

  const { data: petData } = useSWR(
    petId ? `petData${petId}` : null,
    async () => {
      const { data } = await getPetByID(petId);
      return data?.data;
    },
    {
      revalidateOnFocus: false,
    }
  );
  const props = {
    label: "Archive Emergency Contact Information",
    isLoading: isEmergencyContactLoading,
    onBack: () => {
      navigate("/archive/emergency-contact");
    },
    petInfo: petData,
    columns: [
      {
        label: "",
        value: "image",
      },
      {
        label: "Pet Name",
        value: "pet_name",
      },
      {
        label: "Relationship",
        value: "relationship",
      },
      {
        label: "Phone Number",
        value: "phone_number",
      },
    ],
    columnsData: [
      {
        image: petData?.image,
        pet_name: petData?.name,
        relationship: data?.relationship?.slice(0, 25),
        phone_number: formatPhoneNumber(data?.phone_number),
      },
    ],
    detailsData: [
      [
        { name: "First Name", value: data?.first_name },
        { name: "Last Name", value: data?.last_name },
        { name: "Email", value: data?.email },
        { name: "Second Number", value: data?.secondary_number },
      ],
      [
        { name: "Street Add", value: data?.street_address },
        { name: "Street Add 2", value: data?.street_address_2 },
        { name: "City", value: data?.apt_city },
        { name: "State", value: data?.state },
        { name: "Zip", value: data?.zip_code },
        { name: "Country", value: data?.country },
      ],
    ],
  };

  return (
    <FullPageWrapper>
      <ParDataView {...props} />
    </FullPageWrapper>
  );
}

const FullPageWrapper = styled("div")(() => ({}));
